import React from "react";

const DERIVED_COLUMN_GRID_SECTION_IDS = new Set([
    "demerit"
]);

function renderEmptyBody() {
    return (
        <div style={{ minHeight: 120, border: "1px solid #d0d0d0", borderRadius: 4, backgroundColor: "#fafafa" }}>
        </div>
    );
}

export function isDerivedColumnGridSection(section) {
    const sectionId = String(section?.id ?? "").trim();
    return DERIVED_COLUMN_GRID_SECTION_IDS.has(sectionId);
}

export function renderDerivedColumnGridSectionBody({
    section,
    gridSectionPanel,
    stableGridPanel,
    hasGridColumns,
    rowStyle,
    renderContents,
    buildDemandColumns,
    buildDemeritGridColumns,
    toStableAutoHeightPanel
}) {
    if (!hasGridColumns) {
        return renderEmptyBody();
    }

    const renderGridPanel = stableGridPanel || toStableAutoHeightPanel(gridSectionPanel, section.id);
    const querySetColumn = (colDef) => {
        const base = buildDemandColumns(colDef, renderGridPanel);
        return buildDemeritGridColumns(base);
    };

    return renderContents({
        panel: renderGridPanel,
        getRowStyle: rowStyle,
        QuerySetColumn: querySetColumn
    });
}
